import { render, staticRenderFns } from "./OvenHotAir.vue?vue&type=template&id=13533dad"
import script from "./OvenHotAir.vue?vue&type=script&lang=js"
export * from "./OvenHotAir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports